const homeIndex = {
  name: 'homeIndex',
  path: 'homeIndex',
  component: resolve => require(['../../components/pages/homeIndex'], resolve)
}

export default homeIndex



// WEBPACK FOOTER //
// ./src/router/pages/homeIndex.js